<template>
    <div>
        <v-dialog v-model="internalValue" max-width=" 500px">
            <v-card>
                <v-card-title
                    >Tribute Contributors
                    <v-spacer></v-spacer>
                    <a @click.prevent="getTributeUsers" :disabled="loading">
                        <v-icon>mdi-refresh</v-icon> <small>refresh</small>
                    </a>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="users"
                    :search="search"
                    :loading="loading"
                    :expanded.sync="expanded"
                    :options.sync="options"
                    :server-items-length="totalUsers"
                    item-key="id"
                    show-expand
                    @pagination="getTributeUsers"
                >
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="p-1">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-start">Session</th>
                                            <th class="text-center">IP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-1 copyable" @click="copyToClipboard(item.sessionId)">
                                                {{ item.sessionId }}
                                            </td>
                                            <td class="px-1 copyable" @click="copyToClipboard(item.ipAddress)">
                                                {{ item.ipAddress }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </td>
                    </template>
                </v-data-table>
                <v-card-actions class="d-flex justify-end">
                    <v-btn class="no-text-transform" depressed @click="internalValue = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapActions } from 'pinia';
import { debounce } from 'lodash';
import TextButtonInput from '../../ui/TextButtonInput.vue';
import TributeVideoService from '@/services/tributeVideo.service';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { useGlobalState } from '@/stores/globalState';

export default {
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    data() {
        return {
            token: null,
            tributeApi: null,
            loading: false,
            search: '',
            options: {},
            expanded: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    filterable: true,
                    value: 'name',
                },
                {
                    text: 'Relationship',
                    align: 'start',
                    filterable: false,
                    value: 'relationship',
                },
                {
                    text: 'Email',
                    align: 'start',
                    filterable: false,
                    value: 'email',
                },
                {
                    text: 'Phone',
                    align: 'center',
                    filterable: false,
                    value: 'Phone',
                },
                {
                    text: 'Uploads',
                    align: 'center',
                    filterable: false,
                    value: 'slideCount',
                },
            ],
            users: [],
            totalUsers: 0,
            pageSize: 10,
        };
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['tributeRender', 'state'],
    components: { TextButtonInput },
    computed: {
        internalValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        tributeId() {
            return this.tributeVideoStore.id;
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        copyToClipboard(val) {
            navigator.clipboard.writeText(val);
            this.showSnackbar({ message: 'Copied to Clipboard' });
        },
        getTributeUsers: debounce(async function () {
            if (!this.tributeId) {
                this.showSnackbar({ message: 'Invalid tribute ID', color: 'error' });
                return;
            }
            if (this.loading) return;

            try {
                this.loading = true;
                const { sortBy, sortDesc, page, itemsPerPage } = this.options;
                // console.log({ sortBy, sortDesc, page, itemsPerPage });
                const { data } = await this.tributeApi.getTributeUsers(
                    this.tributeId,
                    itemsPerPage,
                    page > 0 ? page - 1 : 0,
                    sortBy?.length ? sortBy[0] : 'name',
                    sortDesc?.length ? !!!sortDesc?.[0] : true,
                );
                if (data?.total > 0) {
                    this.totalUsers = data.total;
                    this.users = data.users;
                }
            } catch (error) {
                console.log(error, 'error');
                this.showSnackbar({ message: 'Error fetching tribute users.', color: 'error' });
            } finally {
                this.loading = false;
            }
        }, 500),
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const response = await this.$auth.getIdTokenClaims();
                this.token = response.__raw;
            }
        },
    },
    async mounted() {
        await this.setAuthToken();
        this.tributeApi = TributeVideoService(this.token);
    },
    watch: {
        options: {
            handler() {
                this.getTributeUsers();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.copyable {
    &:hover {
        color: $sharp-blue;
    }
}
</style>
